import { ComponentRef, Injectable, ViewContainerRef, ElementRef, Renderer2, OnDestroy } from '@angular/core';
import { CitiShopSpeedbumpDialogComponent } from 'src/app/cards/citi-shop/components/citi-shop-speedbump-dialog/citi-shop-speedbump-dialog.component';
import { OfferUtilService } from '../services/offer-util.service';
import { takeWhile } from 'rxjs/operators';
import { Subject } from 'rxjs';

type componentType = 'CitiShopSpeedbumpDialogComponent'
type ComponentRefType = CitiShopSpeedbumpDialogComponent

@Injectable()
export class MktDynamicModalService implements OnDestroy {

 isServiceActive = true;
 private taggingCallSub = new Subject();
 taggingCallEmit$ = this.taggingCallSub.asObservable();

  constructor(
    private offerUtilService: OfferUtilService
  ) { }

  open(viewContainer: ViewContainerRef, componentType: componentType, inputs?: any) {
    let ref;
    if (componentType === 'CitiShopSpeedbumpDialogComponent') {
      ref = viewContainer.createComponent(CitiShopSpeedbumpDialogComponent)
    }
    inputs && Object.keys(inputs).forEach(key => {
      ref.setInput(key, inputs[key])
    });
    const index = viewContainer.indexOf(ref.hostView);
    return { componentRef: ref, index };
  }

  close(viewContainer: ViewContainerRef, componentRef: ComponentRef<ComponentRefType>) {
    const index = viewContainer.indexOf(componentRef.hostView);
    viewContainer.remove(index)
  }

  addModalListenerToElements(containerElement: ElementRef, selector: string, viewContainer: ViewContainerRef, componentType: componentType, inputs?: any) {
    const elements: HTMLElement[] = this.offerUtilService.getDynamicElements(containerElement, selector)
    elements.forEach(element => {
      element.addEventListener('click', () => {
        const {componentRef, index} = this.open(viewContainer, componentType, inputs);
        componentRef.instance.open();
        this.taggingCallSub.next(['open']);
        componentRef.instance.closeEmit.pipe(
          takeWhile(() => this.isServiceActive)
        ).subscribe(val => {
          this.close(viewContainer, componentRef);
          this.taggingCallSub.next(val);
        });
        componentRef.instance.submitEmit.pipe(
          takeWhile(() => this.isServiceActive)
        ).subscribe(val => {
          this.taggingCallSub.next(val);
        });
      });
    });
  }

  ngOnDestroy(): void {
    this.isServiceActive = false;
  }
}
